var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.186,
    height: 42.186,
    viewBox: "0 0 214 214",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil1{fill:#fefefe}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 107,
    r: 107,
    fill: "#201e1e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2749014875072"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M136 112v17c1 2 1 3 2 4H57c-2-1-3-1-5-2-12-6-10-25 3-28 5-1 19 0 25 0h44c5 0 4-4 3-5H61c-3 0-6 0-9 1-2 1-4 2-6 4-8 6-9 21-1 28 3 3 8 7 13 7h107c5 0 10-6 10-12v-16c0-6-5-11-11-11h-18V88c0-7 14-9 18-2 1 1 0 4 2 5 1 1 3 0 3-3 0-6-6-11-12-11-5 0-9 0-12 4-1 1-2 3-3 4-1 3-1 9-1 12 0 5 1 3-2 5-2 3-3 6-3 10zm17 3c0 5-1 8 3 8 3 0 2-4 2-8 0-3-5-3-5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M116 115c-2-1-8-3-8 1 0 2 4 3 6 3-1 2-2 4-2 6s2 3 4 0c1-1 2-3 2-3 1 0 2 2 3 3 2 1 3 1 4 1 2-2-1-5-3-7 2-1 6-2 6-4 0-5-6-1-7-1v-4c-1-2-2-3-3-3-3 0-2 5-2 8zM88 110v5c-2-1-8-3-8 1 0 2 5 3 7 3-1 2-2 3-3 4-1 3 2 6 5 2 0-1 1-2 1-3 2 0 1 0 2 1 0 0 0 1 1 1 2 3 5 2 5-1 0-1-3-4-4-4 1-1 5-2 5-3 2-1 1-4-2-4 0 0-3 2-4 2 0-3 0-7-3-7-1 0-2 2-2 3zM60 110v5c-2-1-7-4-7 1 0 1 1 2 2 2 1 1 3 1 4 1l-3 4c0 2 0 4 2 4s5-5 5-5c1 0 3 4 5 4 1 0 2-1 2-2 0-2-3-4-3-5 1-1 2-1 3-2 2-1 2-1 2-3 0-1-2-2-3-2-1 1-3 2-4 2 0-5 1-7-3-7-1 0-2 1-2 3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPin);
export default __webpack_public_path__ + "static/media/login-pin.081fa0744694307543512ba71be623ec.svg";
export { ForwardRef as ReactComponent };